const types = {
    SET_CATEGORIES_LIST: '[CATEGORIES] SET CATEGORIES LIST',
    SET_CASHIERS_PROFILE: '[CATEGORIES] SET CASHIERS PROFILE',
}

export {
    types
}